import { useLocation, useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { motion } from "framer-motion"
import { Home, Search } from "lucide-react"
import Layout from "@/components/Layout/Layout"

const tips = [
  "Aprende a leer a tu oponente: su forma de jugar dice mucho de su mano.",
  "Aprende a “bluffear”: a veces basta con mirar tu mano para asustar. 😏",
  "Aprende de los jugadores experimentados: observa cómo piensan sus jugadas.",
  "Clasifica y ordena tu colección: te ayudará a armar mazos más rápido.",
  "Conoce el metajuego, pero no tengas miedo de ser creativo.",
  "Conoce las reglas básicas a la perfección; así evitarás malentendidos en partidas.",
  "Construye tu mazo con una estrategia clara, no con “todas tus cartas favoritas”.",
  "Cuida tu curva de oro: un mazo equilibrado gana más que uno desordenado.",
  "El sideboard es tu mejor amigo, úsalo sabiamente.",
  "Prueba tu mazo varias veces antes de un torneo.",
  "Intercambia cartas con respeto: el trueque es parte de la comunidad.",
  "Juega con diferentes mazos: así entiendes mejor las estrategias rivales.",
  "No olvides divertirte: ganar no lo es todo.",
  "No subestimes las cartas Vasallas o Cortesanas: a veces son las que ganan partidas.",
  "No tengas miedo de perder: cada derrota es una lección valiosa.",
  "Nunca subestimes el poder del “topdeck” milagroso.",
  "Protege tus cartas con fundas: ¡nadie quiere un dragón con orejas dobladas! 🐉, elige TopDeck!",
  "Ten paciencia: a veces la mejor jugada es esperar un turno más.",
]

const NotFound = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const randomTip = tips[Math.floor(Math.random() * tips.length)]

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname)
  }, [location.pathname])

  return (
    <Layout className="bg-gradient-to-br from-purple-100 via-pink-100 to-yellow-100 dark:from-gray-900 dark:via-purple-900 dark:to-black">
      <div className="min-h-screen flex flex-col items-center justify-center p-6">
        {/* Fantasma animado */}
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1, rotate: [0, 10, -10, 0] }}
          transition={{ duration: 1, repeat: Infinity, repeatDelay: 2 }}
          className="mb-8"
        >
          <Search className="w-24 h-24 text-purple-700 dark:text-purple-300 drop-shadow-lg" />
        </motion.div>

        {/* Título */}
        <motion.h1
          className="text-7xl font-extrabold text-gray-800 dark:text-gray-100 mb-4"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          404
        </motion.h1>

        {/* Subtítulo divertido */}
        <motion.p
          className="text-lg sm:text-xl text-gray-700 dark:text-gray-300 mb-6 max-w-md text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <span>{randomTip}</span>
          <br />
          <br />
          <br />
          <span className="font-semibold mt-12">La ruta "{location.pathname}"</span> no existe 🚀
        </motion.p>

        {/* Botón volver */}
        <motion.button
          whileHover={{ scale: 1.1, rotate: -1 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate("/")}
          className="flex items-center gap-2 px-6 py-3 rounded-2xl 
                     bg-purple-600 text-white font-semibold shadow-lg 
                     hover:bg-purple-700 transition 
                     dark:bg-purple-500 dark:hover:bg-purple-400"
        >
          <Home className="w-5 h-5" />
          Volver al inicio
        </motion.button>
      </div>
    </Layout>
  )
}

export default NotFound
